import { Map } from 'ol'

export function getMapPixelFromMouseEvent(
  map: Map,
  event: MouseEvent,
): [number, number] {
  const clientX = event.clientX
  const clientY = event.clientY

  const mapRect = map.getTargetElement().getBoundingClientRect()
  const mapX = clientX - mapRect.left
  const mapY = clientY - mapRect.top

  return [mapX, mapY]
}
